import React from "react";
import { usePendingInvitationsContext } from "../../../contexts/PendingInvitationsContext";
import { Button } from "../../ui";
import { useToast } from "../../ui/Toast/ToastProvider";

interface PendingInvitationsPanelProps {
  onAccepted?: (_campaignId: number) => void;
}

const PendingInvitationsPanel: React.FC<PendingInvitationsPanelProps> = ({ onAccepted }) => {
  const { invitations, count, accept, reject } = usePendingInvitationsContext();
  const { showToast } = useToast();

  if (count === 0) return null;

  return (
    <div className="mb-4 bg-amber-400/10 border border-amber-400/30 rounded p-4">
      <h3 className="text-amber-400 text-sm font-semibold tracking-wide mb-3">
        Pending Invitations ({count})
      </h3>
      <ul className="space-y-2">
        {invitations.map((inv) => (
          <li
            key={inv.id}
            className="flex items-center justify-between bg-zinc-900 border border-zinc-800 rounded px-3 py-2"
          >
            <span className="text-zinc-200 text-sm">
              <span className="text-white font-medium">{inv.campaignName}</span>
              <span className="text-zinc-400"> — invited by {inv.invitedBy}</span>
            </span>
            <span className="flex gap-2">
              <Button
                variant="primary"
                size="sm"
                data-testid={`accept-invite-${inv.id}`}
                onClick={async () => {
                  try {
                    const campaignId = await accept(inv.id);
                    onAccepted?.(campaignId);
                  } catch {
                    showToast({
                      type: "error",
                      message: "Failed to accept invitation. Please try again.",
                    });
                  }
                }}
              >
                Accept
              </Button>
              <Button
                variant="secondary"
                size="sm"
                data-testid={`reject-invite-${inv.id}`}
                onClick={() => reject(inv.id)}
              >
                Reject
              </Button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PendingInvitationsPanel;
